import { MenuItem, SelectableMenuItem } from "@noya-app/noya-designsystem";
import { defineTree } from "tree-visit";

export const MenuItemTree = defineTree<MenuItem<string>>((node) => {
  return node.type === "submenu" ? node.items : [];
});

export type ShortcutMenuItem<T extends string> = SelectableMenuItem<T> & {
  shortcut: string;
};

export const getSelectableMenuItems = <T extends string>(
  menuItems: MenuItem<T>[]
): SelectableMenuItem<T>[] => {
  return menuItems
    .flatMap((items) => MenuItemTree.flat(items))
    .flatMap((item) => {
      if (item.type) return [];
      return [item as SelectableMenuItem<T>];
    });
};

export const getShortcutMenuItems = <T extends string>(
  menuItems: MenuItem<T>[]
): ShortcutMenuItem<T>[] => {
  return getSelectableMenuItems(menuItems).filter(
    (item): item is ShortcutMenuItem<T> => !!item.shortcut
  );
};
